/* eslint-disable react/sort-comp */
import { captureOwnerStack, Component, ErrorInfo, PropsWithChildren, ReactNode } from 'react';

import Whoops from 'app/pages/error/Whoops';
import { logError } from 'app/utils/lib/logging';

// Local Typings
interface Props {
  fallback?: ReactNode;
}
interface State {
  hasError: boolean;
}

// see https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
// Component Definition
class ErrorBoundary extends Component<PropsWithChildren<Props>, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: ErrorInfo) {
    logError(
      error,
      info.componentStack,
      captureOwnerStack(),
    );
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? <Whoops />;
    }

    return this.props.children;
  }
}
export default ErrorBoundary;
